import { render, staticRenderFns } from "./failPage.vue?vue&type=template&id=8cd019d2&scoped=true"
import script from "./failPage.vue?vue&type=script&lang=js"
export * from "./failPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd019d2",
  null
  
)

export default component.exports